const Palette = (): any => ({
  primary: {
    contrastText: "#0A0A0A",
    main: "#2d68f7",
  },
  secondary: {
    contrastText: "#ffffff",
    main: "#EAF0FE",
  },
});

export default Palette;
